module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"placeholder":"Schnellsuche: Projekt","fixedPrice":"Fixpreis"},"en":{"placeholder":"Fast search: project","fixedPrice":"Fixed price"}}')
  delete Component.options._Ctor
}
